import styles from '@features/productPreview/sections/UniversalShoppingValues/ShoppingValues.styles';
import { TUSPItemType } from '@features/cms/typescript';
import IconWithText from './IconWithText';
type PropsType = {
  data: TUSPItemType[];
  isNarrowerThanTablet: boolean;
};
const UniversalShoppingValues = ({
  data,
  isNarrowerThanTablet
}: PropsType) => {
  const firstRow = data.slice(0, 2);
  const secondRow = data.slice(2, 4);
  return isNarrowerThanTablet ? <>
      <div sx={styles.shoppingValueMobileContainer}>
        {firstRow.map(value => <IconWithText data={value} key={value.itemId} />)}
      </div>
      <div sx={styles.shoppingValueMobileContainer}>
        {secondRow.map(value => <IconWithText data={value} key={value.itemId} />)}
      </div>
    </> : <div sx={styles.shoppingValueSectionContainer(data.length)}>
      {data.map(value => <IconWithText data={value} key={value.itemId} />)}
    </div>;
};
export default UniversalShoppingValues;